import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import {
  IOpenBulkDialogData,
  IOpenDialogData,
} from 'pages/dashboard/order-lists/type/open-dialog-state.interface';
import {
  bulkCancelStockTransfer,
  bulkRetryUpdateFailedStockTransfer,
} from 'redux-stores/actions';

export const OpenDialogConfig: Record<string, IOpenDialogData | null> = {
  retry: {
    title: 'Retry Update Bin Transfer',
    content: (stockTransferNumber: string): string => {
      return `Are you sure to retry ${stockTransferNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      transferNumber: string,
      location?: number,
    ): void => {
      dispatch(
        bulkRetryUpdateFailedStockTransfer({
          transferNumbers: [transferNumber],
          location,
        }),
      );
    },
  },
};

export const OpenBulkDialogConfig: Record<string, IOpenBulkDialogData | null> =
  {
    Retry: {
      title: 'Retry Update Bin Transfers',

      content: (stockTransferNumbers: string[]): string => {
        return `Are you sure to retry following bin transfer tasks: \n\n ${stockTransferNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        transferNumbers: string[],
        location?: number,
      ): void => {
        dispatch(
          bulkRetryUpdateFailedStockTransfer({ transferNumbers, location }),
        );
      },
    },
    Cancel: {
      title: 'Cancel Bin Transfers',

      content: (stockTransferNumbers: string[]): string => {
        return `Are you sure to cancel following bin transfer tasks: \n\n ${stockTransferNumbers.join(
          '\n',
        )}?`;
      },
      onConfirm: (
        dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
        transferNumbers: string[],
        location?: number,
      ): void => {
        dispatch(bulkCancelStockTransfer({ transferNumbers, location }));
      },
    },
  };
